// A simple implementation of lodash's set function.
// It's not as robust, but it handles our use case of updating nested properties.
export const set = (obj: any, path: string, value: any): any => {
    const keys = path.replace(/\[(\w+)\]/g, '.$1').replace(/^\./, '').split('.');

    // Create a shallow copy of the object to start the process
    const newObj = { ...obj };

    keys.reduce((acc, key, index) => {
        if (index === keys.length - 1) {
            acc[key] = value;
            return acc;
        }

        // If path doesn't exist, create it.
        // Create a copy of the nested object/array to avoid mutation.
        if (!acc[key] || typeof acc[key] !== 'object') {
            acc[key] = /^\d+$/.test(keys[index + 1]) ? [] : {};
        } else {
            acc[key] = Array.isArray(acc[key]) ? [...acc[key]] : { ...acc[key] };
        }

        return acc[key];
    }, newObj);

    return newObj;
}; 